import { ButtonProps } from '@material-ui/core';
import launchPointConfig, { AlmeLaunchPointConfig } from '../AlmeLaunchPoint/AlmeLaunchPointConfig';

interface LaunchToolsConfig extends AlmeLaunchPointConfig {
    launchButton: {
        color: ButtonProps['color'];
        variant: ButtonProps['variant'];
    };
}

export interface AlmeLaunchToolsConfig {
    launchTools: LaunchToolsConfig;
}

const defaultConfig: AlmeLaunchToolsConfig = {
    launchTools: {
        launchButton: {
            color: 'secondary' as const,
            variant: 'contained' as const,
        },
        ...launchPointConfig,
    },
};

export default defaultConfig;